import { render } from "./IconAccountBox.vue?vue&type=template&id=a2ad0fa8"
import script from "./IconAccountBox.vue?vue&type=script&lang=js"
export * from "./IconAccountBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__